import { type DietaryRestrictionsTypes } from '../setup';

// ─────────────────────────────────────────────────────────────────────────────

export function checkIfHasSelectedPreferences(restrictions: DietaryRestrictionsTypes) {
  return Object.values(restrictions).some(Boolean);
}
